/* eslint-disable
    @typescript-eslint/no-explicit-any
*/
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {assert} from 'Asserts';
import * as BenchlingUtil from 'BenchlingUtil';
import getTestProps from 'test/lib/cypress/getTestProps';

export interface SidebarItemProps {
  active?: boolean;
  clickHandler?: (...args: Array<any>) => any;
  contextMenuHandler?: (...args: Array<any>) => any;
  icon: React.ReactElement;
  name: string;
  badge?: React.ReactNode;
  link?: string;
  dataTestAttrsKey?: string;
}

class SidebarItem extends React.Component<SidebarItemProps> {
  static defaultSidebarItemProps = {
    active: false,
    faded: false,
  };

  render(): JSX.Element {
    assert(!(this.props.clickHandler && this.props.link), 'Cannot pass both clickHandler and link props');
    // If a link is passed, have BenchlingUtil.navigate handle the click since it keeps the anchor looking
    // like a link while still supporting single-page app routing
    const clickHandler = this.props.link ? BenchlingUtil.navigate : this.props.clickHandler;
    return (
      <a
        className={css(styles.anchor)}
        href={this.props.link}
        onClick={clickHandler}
        onContextMenu={this.props.contextMenuHandler}
        {...(this.props.dataTestAttrsKey
          ? {...getTestProps({component: 'SidebarItem', element: 'nav', key: this.props.dataTestAttrsKey})}
          : {...getTestProps({component: 'SidebarItem', element: 'nav'})})}
      >
        <div
          className={classNames({
            sidebarItem: true,
            active: this.props.active,
          })}
        >
          {this.props.icon}
          <span className={css(styles.content)}>
            <span className={classNames('browser-file-name', css(styles.contentItem))}>
              {
                // TODO(T4025): Test this codepath
                // To ensure that item has full height if name is empty
                <span className="u-display-inline-block">{this.props.name}</span>
              }
            </span>
            <span className={css(styles.contentItem)}>{this.props.badge}</span>
          </span>
        </div>
      </a>
    );
  }
}

const styles = StyleSheet.create({
  anchor: {
    // Override default anchor styling with existing Benchling styling
    color: 'inherit',
    textDecoration: 'inherit',
  },
  content: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  contentItem: {
    display: 'flex',
    fontSize: '13px',
  },
});

export default SidebarItem;
